// Loaded once per product-tabs section (twice on some templates); register the
// delegated listener only once.
if (!window.__kocProductTabs) {
window.__kocProductTabs = true;
document.addEventListener('click', function (e) {
  var tab = /** @type {Element} */ (e.target)?.closest('.product-tabs__tab');
  if (!tab) return;

  var section = tab.closest('.product-tabs');
  if (!section) return;

  var target = /** @type {HTMLElement} */ (tab).dataset.tab;

  section.querySelectorAll('.product-tabs__tab').forEach(function (/** @type {Element} */ t) {
    t.classList.remove('product-tabs__tab--active');
    t.setAttribute('aria-selected', 'false');
  });
  section.querySelectorAll('.product-tabs__panel').forEach(function (/** @type {Element} */ p) {
    p.classList.remove('product-tabs__panel--active');
  });

  tab.classList.add('product-tabs__tab--active');
  tab.setAttribute('aria-selected', 'true');

  var panel = section.querySelector('[data-panel="' + target + '"]');
  if (panel) panel.classList.add('product-tabs__panel--active');
});
}
